import React, {Component} from "react";
import Head from "../../components/Head";
import {withTranslate} from "react-redux-multilingual"
import globalMiddleware from "../../hocs/globalMiddleware";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {baseLink, getHeader, requestRefundURL} from "../../config";
import axios from "axios";
import Maintenance from "./PaymentTerms";
import {Skeleton} from "react-loading-skeleton-placeholders";
import SweetAlert from 'react-bootstrap-sweetalert';
import {withRouter} from "react-router-dom";

class Refund extends Component {

    state = {
        refundTerms: null,
        error500: false,
        showRequestRefund: false,
        requestRefundTitle: null,
        requestRefundText: null,
        requestRefundLoading: false,
        requestRefundSuccess: false,
    };


    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
        axios.get(baseLink + "system/policies?type=3", {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                console.log("response", res);
                this.setState({
                    refundTerms: res.data.Response,
                });
            }
        }).catch(err => {
            console.log("error", err);
            this.setState({
                error500: true,
            });
        })
    }

    requestRefund = () => {
        this.setState({
            requestRefundLoading: true,
        });
        axios.post(requestRefundURL, {"reservation_id": this.props.match.params ? this.props.match.params.reservation_id : null},
            {headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                this.setState({
                    showRequestRefund: true,
                    requestRefundTitle: this.props.translate('success'),
                    requestRefundText: this.props.translate('request_refund_success'),
                    requestRefundLoading: false,
                    requestRefundSuccess: true,
                })
            } else {
                this.setState({
                    showRequestRefund: true,
                    requestRefundTitle: this.props.translate('sorry'),
                    requestRefundText: response.data.Error.desc,
                    requestRefundLoading: false,
                })
            }
        }).catch(err => {
            this.setState({
                showRequestRefund: true,
                requestRefundTitle: this.props.translate('sorry'),
                requestRefundText: this.props.translate('something_wrong'),
                requestRefundLoading: true,
            });
        })
    };
    handleConfirmSweetAlert = () => {
        this.setState({showRequestRefund: false});
        if (this.state.requestRefundSuccess) {
            this.props.history.push('/my-appointments', {
                pastReservationRefund: true
            })
        }
    };

    render() {

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];

        if (this.state.error500) {
            return (
                <Maintenance/>
            )
        }
        const refundTermsList = this.state.refundTerms ?
            (
                <div>
                    <h1>{this.state.refundTerms.name}</h1>
                    <p dangerouslySetInnerHTML={{__html: this.state.refundTerms.condition}}/>
                </div>
            ) :
            (<div>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
            </div>);
        return (
            <div className="Privacy">
                <Head title={this.props.translate("refund_title")} history={history}/>
                <section className="ftco-section doctors-list-all" id="doctors-list-all">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                {refundTermsList}
                            </div>
                        </div>
                        {this.state.refundTerms ?
                            <div className="row mt-50" id="refund-area">
                                <div className="col-md-12 refund-btn text-center relative">
                                    <button className="cursor-pointer" onClick={this.requestRefund}>
                                        {this.props.translate('agree')}
                                    </button>
                                    <span id="loading" className="refund-loading"
                                          hidden={this.state.requestRefundLoading === false}>
                                                    <img style={{width: "30px", height: "30px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                                </div>
                                <div className="col-md-12 refund-cancel-btn text-center">
                                    <Link to={{
                                        pathname: "/my-appointments",
                                        pastReservationRefund: true
                                    }}>{this.props.translate('dont_agree')}</Link>
                                </div>
                            </div> : null}

                    </div>
                </section>
                {/********************* agree Request Refund ************/}
                <SweetAlert
                    show={this.state.showRequestRefund}
                    title={this.state.requestRefundTitle}
                    onConfirm={this.handleConfirmSweetAlert}
                    warning
                    confirmBtnBsStyle="sweet success-sweet"
                    confirmBtnText={this.props.translate("ok")}
                >
                    {this.state.requestRefundText}
                </SweetAlert>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(withRouter(Refund))));